import { ServiceVariation } from "@/services/backend/omni/servicevariation/types/service-variation";
import { UUID } from "@bitory-gmbh/nidavellir";
import { PositionBaseData } from "./position-base-data";

/** Mirrors `positions.DefaultBaseDataKey`, backend/core/omni/domain/positions/base_data.go. */
export function omniPositionsBaseDataKey(serviceKind: string): string {
  return `omni.positions.baseData.${serviceKind}`;
}

/** Mirrors `positions.BaseData`, backend/core/omni/domain/positions/base_data.go. */
export type PositionsBaseData = {
  id: UUID;
  companyId: UUID;
  label: string;
  createdAt: string;
  updatedAt: string;
  serviceKind: string;
  serviceVariation: ServiceVariation;
  options: PositionBaseData[];
};

/** Mirrors `positions.BaseDataPatch`, backend/core/omni/domain/positions/base_data.go. */
export type PositionsBaseDataPatch = {
  label?: string;
  serviceVariation?: ServiceVariation;
  options?: PositionBaseData[];
};

export function patchPositionsBaseData(
  baseData: PositionsBaseData,
  patch: PositionsBaseDataPatch,
): PositionsBaseData {
  return { ...baseData, ...patch };
}
